<template>
<v-card v-if="productsSales">
    <v-card-title class="subtitle-1">
        <v-icon color="green lighten-2" class="mr-3">{{ mdiChartBoxOutline }}</v-icon>상품별매출통계
    </v-card-title>
    <v-card-text class="pa-0">
        <v-divider />
        <v-data-table :items="productsSales" :headers="productsSalesHeaders" hide-default-footer>
            <template v-slot:item.product="{ item }">
                <v-row v-if="item.product" align="center">
                    <v-col md="auto">
                        <v-img v-if="item.product.thumb" :src="item.product.thumb" max-width="32" max-height="32"></v-img>
                        <v-responsive v-else width="32" height="32">
                            <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                <v-icon>mdi-image</v-icon>
                            </v-row>
                        </v-responsive>
                    </v-col>
                    <v-col>
                        <div class="text-start">{{ item.product.name }}</div>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.purchasePrice="{ item }">
                <div class="pr-4">{{ item.purchasePrice.format() }}</div>
            </template>
            <template v-slot:item.purchaseAmount="{ item }">
                <div class="pr-4">{{ item.purchaseAmount.format() }}</div>
            </template>
        </v-data-table>
    </v-card-text>
</v-card>
</template>

<script>
import api from "@/api";

import { mdiChartBoxOutline  } from "@mdi/js";
export default {
    data(){
        return {
            mdiChartBoxOutline,
            
            filter: {
                startDate: (new Date().addMonth(-1)).toDate(),
                endDate: Date.now().toDate()
            },

            productsSales: null,
            productsSalesHeaders: [
                {
                    text: "상품정보",
                    value: "product"
                },
                {
                    text: "판매금액",
                    align: "center",
                    width: 100,
                    value: "purchasePrice"
                },
                {
                    text: "판매수량",
                    align: "center",
                    width: 120,
                    value: "purchaseAmount"
                },
            ],
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search();
        },
        async search(){
            try{
                var { productsSales } = await api.console.statistics.getProductsSales({
                    headers: { limit: 10 },
                    params: this.filter
                });
                this.productsSales = productsSales;
            }
            catch(error){
                console.error(error);
            }
        }
    }
}
</script>